import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import NativeAttributeRequirementsAPI from 'dashboard/api/nativeAttributeRequirements';

export const PREDEFINED_ATTRIBUTES = [
  { key: 'priority'},
  { key: 'assignee' },
  { key: 'tag'},
  { key: 'team' },
];

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getRequirements(_state) {
    return _state.records.reduce((acc, r) => {
      acc[r.key] = true;
      return acc;
    }, {});
  },
  getRequirementIdMap(_state) {
    return _state.records.reduce((acc, r) => {
      acc[r.key] = r.id;
      return acc;
    }, {});
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getRequirements({ commit }) {
    commit(types.SET_NATIVE_ATTRIBUTE_UI_FLAG, { isFetching: true });
    try {
      const response = await NativeAttributeRequirementsAPI.getRequirements();
      commit(types.SET_NATIVE_ATTRIBUTE_REQUIREMENTS, response.data.payload);
    } catch (error) {
      // Tratar erro se necessário
    } finally {
      commit(types.SET_NATIVE_ATTRIBUTE_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createRequirement({ commit }, { key }) {
    const attribute = PREDEFINED_ATTRIBUTES.find(attr => attr.key === key);
    if (!attribute) return;

    commit(types.SET_NATIVE_ATTRIBUTE_UI_FLAG, { isCreating: true });
    try {
      const response = await NativeAttributeRequirementsAPI.create(
        attribute.key,
        attribute.type
      );
      // Correção aqui:
      commit(types.ADD_NATIVE_ATTRIBUTE_REQUIREMENT, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_NATIVE_ATTRIBUTE_UI_FLAG, { isCreating: false });
    }
  },

  // eslint-disable-next-line no-shadow
  delete: async function deleteRequirement({ commit, getters }, key) {
    const id = getters.getRequirementIdMap[key];
    if (!id) return;

    commit(types.SET_NATIVE_ATTRIBUTE_UI_FLAG, { isDeleting: true });
    try {
      await NativeAttributeRequirementsAPI.delete(id);
      commit(types.DELETE_NATIVE_ATTRIBUTE_REQUIREMENT, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_NATIVE_ATTRIBUTE_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_NATIVE_ATTRIBUTE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.ADD_NATIVE_ATTRIBUTE_REQUIREMENT]: MutationHelpers.create,
  [types.SET_NATIVE_ATTRIBUTE_REQUIREMENTS]: MutationHelpers.set,
  [types.DELETE_NATIVE_ATTRIBUTE_REQUIREMENT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
